import { defineComponent as e, openBlock as t, createElementBlock as n, normalizeClass as r, renderSlot as o, createElementVNode as a } from "vue";
const s = ["id", "aria-labelledby"], d = { class: "uikit-overflow-hidden" }, u = /* @__PURE__ */ e({
  inheritAttrs: !1,
  __name: "BaseAccordionContent",
  props: {
    id: {},
    accordionOpen: { type: Boolean }
  },
  setup(c) {
    return (i, l) => (t(), n("div", {
      id: `accordion-text-${i.id}`,
      role: "region",
      "aria-labelledby": `accordion-title-${i.id}`,
      class: r(["uikit-grid uikit-overflow-hidden uikit-px-5 uikit-text-sm uikit-text-w-black uikit-transition-[grid-template-rows,opacity,padding,margin] uikit-duration-300 uikit-ease-in-out", [
        i.accordionOpen ? i.$attrs["accordion-open-classes"] : i.$attrs["accordion-close-classes"],
        i.accordionOpen ? "uikit-grid-rows-[1fr] uikit-opacity-100" : "uikit-grid-rows-[0fr] uikit-opacity-0",
        i.$attrs["accordion-classes"]
      ]])
    }, [
      o(i.$slots, "custom_accordion_content", { isOpen: i.accordionOpen }, () => [
        a("div", d, [
          o(i.$slots, "default", { isOpen: i.accordionOpen })
        ])
      ])
    ], 10, s));
  }
});
export {
  u as _
};
